export default {
  props: {
    report: {
      type: Object,
      default: () => {},
    },
  },
};
